export default __webpack_public_path__ + "static/media/SecurePhone.39a49038.png";